<template>
  <div id="container" style="margin: 0;height: 100%;"></div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';

let interval = null

export default {
  data() {
    return {
      map: null,
      AMap: null,
      license: '',
      marker: null,
    };
  },
  methods: {
    initMarker({ x, y, title = '北京', text = '冀J12345', color, data: { driver, tel, memo, state2, gpstime, speed, direct, type } }) {
      var marker = new this.AMap.Marker({
        position: new this.AMap.LngLat(x, y),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title,
        offset: new this.AMap.Pixel(0, 16)
      });

      // 给标记点绑定数据
      marker['license'] = text
      marker['x'] = x
      marker['y'] = y

      marker.setContent(`<div class="marker" >
        <div class="tit ${color ? 'tit' + color : ''}">${text}<div class="after"></div></div>
        <div class="cont ${type === '在线' ? '' : 'off'}" id="mark${text}" style="transform:rotate(${90 + direct}deg);"></div>
      </div>`);

      // console.log(marker)

      var tit = `${text}`, content = [];
      if (driver) content.push(`司机：${driver}`);
      if (tel) content.push(`电话：${tel}`);
      if (gpstime) {
        // const { y, m, d } = this.getDateStrObj(gpstime)
        // content.push(`时间：${y}-${m}-${d}`);
        content.push(`时间：${gpstime}`);
      }
      if (state2) content.push(`状态：${state2}`);
      content.push(`速度：${speed}`);
      if (memo) content.push(`位置：${memo}`);
      var infoWindow = new this.AMap.InfoWindow({
        isCustom: true,  //使用自定义窗体
        content: this.createInfoWindow(tit, content.join("<br/>")),
        offset: new this.AMap.Pixel(16, -45)
      });

      //鼠标点击marker弹出自定义的信息窗体
      // this.AMap.event.addListener(marker, 'click', function () {
      //   infoWindow.open(this.map, marker.getPosition());
      // });

      setTimeout(() => {
        const mark = document.querySelector(`#mark${text}`)
        const mapp = this.map
        const fun = this.showAllLisence
        mark.onclick = function () {
          console.log(this)
          // 显示全部
          fun()
          // 隐藏当前
          const tit = this.previousElementSibling
          tit.classList.add('hide')
          // 打开窗体
          infoWindow.open(mapp, marker.getPosition());
        }
      }, 1);

      // 将创建的点标记添加到已有的地图实例：
      this.map.add(marker);

      // 储存标记点
      this.marker = marker

      return marker;
    },
    //构建自定义信息窗体
    createInfoWindow(title, content) {
      var info = document.createElement("div");
      info.className = "custom-info input-card content-window-card";

      //可以通过下面的方式修改自定义窗体的宽高
      //info.style.width = "400px";
      // 定义顶部标题
      var top = document.createElement("div");
      var titleD = document.createElement("div");
      var closeX = document.createElement("img");
      top.className = "info-top";
      titleD.innerHTML = title;
      closeX.src = "https://webapi.amap.com/images/close2.gif";
      closeX.onclick = this.closeInfoWindow;
      closeX.style.cursor = 'pointer';

      top.appendChild(titleD);
      top.appendChild(closeX);
      info.appendChild(top);

      // 定义中部内容
      var middle = document.createElement("div");
      middle.className = "info-middle";
      middle.style.backgroundColor = 'white';
      middle.innerHTML = content;
      info.appendChild(middle);

      // 定义底部内容
      var bottom = document.createElement("div");
      bottom.className = "info-bottom";
      bottom.style.position = 'relative';
      bottom.style.top = '0px';
      bottom.style.margin = '0 auto';
      var sharp = document.createElement("img");
      sharp.src = "https://webapi.amap.com/images/sharp.png";
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },
    //关闭信息窗体
    closeInfoWindow() {
      this.map.clearInfoWindow();
      this.showAllLisence()
    },
    showAllLisence() {
      const array = document.querySelectorAll('.marker .hide')
      for (let i = 0; i < array.length; i++) {
        const e = array[i];
        e.classList.remove('hide')
      }
    },
    getData(isRefresh) {
      this.post(`car/getcarlocation`, { license: this.license }, res => {
        // console.log(res)
        if (res.msg !== 'success') {
          this.$message({
            type: 'error',
            message: '获取数据失败，请稍后重试！'
          });
          return
        }
        const { data } = res;
        if (data) {
          console.log('data', { ...data })
          const { lng, lat } = data
          if (isRefresh && this.marker) {
            this.marker.setMap(null)
          }
          if (data.type === '离线') {
            this.$message({
              type: 'error',
              message: '设备已离线',
            });
            clearInterval(interval)
          }
          if (lng && lat) {
            this.map.setCenter([lng, lat]);
            this.initMarker({
              x: lng,
              y: lat,
              text: this.license,
              data: data,
            })
          }
        }
      }, err => {
        clearInterval(interval)
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    const { license } = this.$route.query
    // console.log(this.$route)
    // console.log(license)
    this.license = license
    AMapLoader.load({
      key: "00ef8e16ac1dc02bfea2dd248b61a58f", // 申请好的Web端开发者Key，首次调用 load 时必填
      version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      // plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    })
      .then((AMap) => {
        this.map = new AMap.Map("container", {
          center: [117.317026, 38.359087],
          zoom: 15,
        });
        this.AMap = AMap
        this.$nextTick(this.getData)
        interval = setInterval(() => {
          this.getData(true)
        }, 30000);
      })
      .catch((e) => {
        console.log(e);
      });
  },
  beforeRouteLeave(to, from, next) {
    // 监听到页面离开时调用
    // to: 即将要进入的目标的路由对象
    // from: 当前导航正要离开的路由
    // next: 是一个function，一定要调用该方法，否则路由不会跳转。
    // console.log(from)
    // console.log(to)
    clearInterval(interval)
    // 一定要调用next
    next()
  },
};
</script>

<style lang="less" scoped>
#container {
  width: 100%;
  height: 100%;

  /deep/ .marker {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tit {
      background-color: rgba(0, 0, 0, 0.65);
      color: #FFF;
      padding: 5px;
      border-radius: 5px;
      min-width: 80px;
      text-align: center;
      margin-bottom: 8px;
      position: relative;

      &.hide {
        visibility: hidden;
      }

      .after {
        contain: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 0px;
        border: 5px solid transparent;
        border-top-color: rgba(0, 0, 0, 0.65);
      }
    }

    .tit1 {
      background-color: #F56C6C;

      .after {
        border-top-color: #F56C6C;
      }
    }

    .tit2 {
      background-color: #3696F9;

      .after {
        border-top-color: #3696F9;
      }
    }

    .tit3 {
      background-color: #C832C8;

      .after {
        border-top-color: #C832C8;
      }
    }

    .tit4 {
      background-color: #00CFBA;

      .after {
        border-top-color: #00CFBA;
      }
    }

    .tit5 {
      background-color: #67C23A;

      .after {
        border-top-color: #67C23A;
      }
    }

    .tit6 {
      background-color: #FE3E3E;

      .after {
        border-top-color: #FE3E3E;
      }
    }

    .cont {
      width: 55px;
      height: 55px;
      background: url(../../../assets/img/fleet01.png) no-repeat center center;
      background-size: 100%;
      margin-top: -5px;

      &.off {
        background-image: url(../../../assets/img/fleet01_off.png);
      }
    }
  }
}



/deep/.custom-info {
  border: solid 1px silver;

  &.content-window-card {
    position: relative;
    box-shadow: none;
    bottom: 0;
    left: 0;
    width: auto;
    padding: 0;

    p {
      height: 2rem;
    }

    .info-top {
      position: relative;
      background: none repeat scroll 0 0 #F9F9F9;
      border-bottom: 1px solid #CCC;
      border-radius: 5px 5px 0 0;

      div {
        display: inline-block;
        color: #333333;
        font-size: 14px;
        font-weight: bold;
        line-height: 31px;
        padding: 0 10px;
      }

      img {
        position: absolute;
        top: 10px;
        right: 10px;
        transition-duration: 0.25s;

        &:hover {
          box-shadow: 0px 0px 5px #000;
        }
      }
    }

    .info-middle {
      font-size: 12px;
      padding: 10px 6px;
      line-height: 20px;

      img {
        float: left;
        margin-right: 6px;
      }
    }

    .info-bottom {
      height: 0px;
      width: 100%;
      clear: both;
      text-align: center;

      img {
        position: relative;
        z-index: 104;
      }

      span {
        margin-left: 5px;
        font-size: 11px;
      }
    }
  }
}
</style>
